// extracted by mini-css-extract-plugin
export default {"title":"styles_title__S4nMT","table":"styles_table__PWOFj"};